/* eslint-disable @nx/enforce-module-boundaries */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiKitModule } from '@serviceplan/ui-kit';
import { ClientAssetsModule } from '@thehubz/client/assets-module';
import { ClientCoreModule, CommonUtilityLib, MatComponentsModule } from '@thehubz/client/core';
import { ClientNavigationModule } from '@thehubz/client/navigation';
import { LayoutComponent } from './components/layout.component';
import { CustomRoutingModule } from './custom-routing.module';

@NgModule({
  imports: [CommonModule, ClientCoreModule, MatComponentsModule, UiKitModule, ClientNavigationModule, ClientAssetsModule, CustomRoutingModule],
  declarations: [LayoutComponent],
  providers: [CommonUtilityLib],
})
export class CustomLayoutModule {}
